import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import TestsRequests from "services/tests";
import MangeWordsTableHeading from "./ManageWordsTableHeading";
import ManageWordsTableItem from "./ManageWordsTableItem";

const MangeWordsTable = ({ searchMode, searchInput }) => {
    const dispatch = useDispatch();
    const { words, wordsCurrentPage, wordsTotalPage } = useSelector(
      ({ tests }) => tests
    );
  
    useEffect(() => {
      if (searchMode) {
        dispatch(TestsRequests.getWords(1, searchInput));
      } else {
        dispatch(TestsRequests.getWords(1));
      }
    }, [searchInput, searchMode]);
  
    const handleChangePagination = (_, value) => {
      if (searchMode) {
        dispatch(TestsRequests.getWords(value, searchInput));
      } else {
        dispatch(TestsRequests.getWords(value));
      }
    };
  
    return (
      <div className="Cmt-table-responsive">
        {words &&
          (words.length === 0 ? (
            <Box
              display={"flex"}
              justifyContent={"center"}
              paddingTop={"30px"}
              paddingBottom={"20px"}
            >
              <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
            </Box>
          ) : (
            <Table>
              <TableHead>
                <MangeWordsTableHeading />
              </TableHead>
              <TableBody>
                {words.map((item) => (
                  <ManageWordsTableItem
                    data={item}
                    key={item._id}
                    id={item._id}
                  />
                ))}
              </TableBody>
            </Table>
          ))}
        {words.length !== 0 ? (
          <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
            <Pagination
              count={wordsTotalPage}
              color="primary"
              page={wordsCurrentPage}
              onChange={handleChangePagination}
            />
          </Box>
        ) : null}
      </div>
    );
  };
  
  export default MangeWordsTable;